// Game version - update this when making a new release
export const GAME_VERSION = 'v0.0.9';

// Game constants - tweak these to change game feel
export const GAME_CONFIG = {
  // Display
  WIDTH: 1280,
  HEIGHT: 720,
  
  // World - infinite procedural generation
  CHUNK_SIZE: 1024,           // Size of each chunk in pixels (smaller = less per chunk)
  RENDER_DISTANCE: 1,         // How many chunks to render around player (1 = 3x3 = 9 chunks)
  
  // Player ship stats are now in src/config/ships.ts per ship class

  // Camera
  CAMERA: {
    LERP: 0.1,                // Camera smoothing (0-1, lower = smoother)
    ZOOM_DEFAULT: 0.5,        // 50% - default zoom when entering game
    ZOOM_MIN: 0.25,           // 25% - minimum zoom (one more scroll triggers constellation map)
    ZOOM_MAX: 1.0,            // 100% - max zoom in (closest view)
    // Fixed zoom levels for cleaner stepping (scroll jumps between these)
    ZOOM_LEVELS: [0.25, 0.33, 0.5, 0.67, 0.8, 1.0],
    // Max zoom-out (min zoom value) per ship size — bigger ships see more battlefield
    ZOOM_MIN_BY_SHIP_SIZE: {
      small: 0.5,             // Corvettes/frigates — tight view
      medium: 0.33,           // Destroyers/cruisers — moderate view
      large: 0.25,            // Battleships/carriers/dreadnoughts — full zoom out
    } as Record<string, number>,
  },
  
  // World generation
  GENERATION: {
    ASTEROID_DENSITY: 0.000002, // Asteroids per pixel² in chunk (~8 per 1024 chunk - sparse like real space)
    STAR_DENSITY: 0.000015,     // Background stars density (subtle)
    // Asteroid size range: 1=small(16px), 2=medium(32px), 3=large(48px), 4=huge(64px)
    MIN_ASTEROID_SIZE: 2,     // Smallest that can spawn (1-4)
    MAX_ASTEROID_SIZE: 4,     // Largest that can spawn (1-4)
  },
  
} as const;

// Colors for easy theming - New palette
export const COLORS = {
  BACKGROUND: 0x0f1b26,        // Dark blue
  BACKGROUND_LIGHT: 0x1a2a38,  // Slightly lighter for panels
  TEXT_LIGHT: 0xf5e8d1,        // Cream/beige
  TEXT_DARK: 0x0f1b26,         // Dark blue
  PRIMARY: 0x20a5a6,           // Teal
  SECONDARY: 0xdd5639,         // Orange/red
  STARS: [0xf5e8d1, 0x20a5a6, 0xdd5639, 0xffffff],
  UI_PRIMARY: 0x20a5a6,        // Teal
  UI_SECONDARY: 0xf5e8d1,      // Cream
  UI_WARNING: 0xdd5639,        // Orange/red
  UI_DANGER: 0xdd5639,         // Orange/red
  SHIP_TRAIL: 0x20a5a6,        // Teal
} as const;

// Input mappings
export const CONTROLS = {
  THRUST: ['W', 'UP'],
  REVERSE: ['S', 'DOWN'],
  STRAFE_LEFT: ['A'],        // Side thrusters
  STRAFE_RIGHT: ['D'],       // Side thrusters
  ROTATE_LEFT: ['LEFT'],     // Arrow keys rotate
  ROTATE_RIGHT: ['RIGHT'],   // Arrow keys rotate
  FIRE: ['SPACE'],
  INTERACT: ['E'],
  INVENTORY: ['I', 'TAB'],
  MAP: ['M'],
  ZOOM_IN: ['Q'],
  ZOOM_OUT: ['Z'],
  MENU: ['ESC'],             // Open/close menu
} as const;
